import { render, staticRenderFns } from "./TwoFactorAuthentication.vue?vue&type=template&id=0b11f87d&scoped=true&"
import script from "./TwoFactorAuthentication.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorAuthentication.vue?vue&type=style&index=0&id=0b11f87d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b11f87d",
  null
  
)

export default component.exports